// extracted by mini-css-extract-plugin
export default {"testimonyCard":"testimonialCard_testimonyCard__-0zKF","testimonialCard":"testimonialCard_testimonialCard__S2uys","testimonialIcon":"testimonialCard_testimonialIcon__47mFl"};